import { get } from "../axiosUitils";

const basePath = "/city_collab/sop";

export interface SOPResponse {
  id: string;
  is_active: string;
  created_on: string;
  updated_on: string;
  created_by: string;
  updated_by: string;
  tenant: string;
  title: string;
  department: string;
  created_by_name: string;
  category: string;
  versiontype: string;
  description: string;
  sopimage: string; // JSON string
  tags: string | null;
  organizationid: string;
}

export interface SOPImageFile {
  id: string;
  file_type: string;
  file_size: number;
  file_hash: string;
  file_path: string;
  file_path_optimized: string | null;
  file_path_thumbnail: string | null;
  file_original_name: string;
}

class SOPService {
  /**
   * Get all SOPs by organization ID
   */
  getAllSOPs = async (organizationId: string): Promise<SOPResponse[]> => {
    if (!organizationId) {
      throw new Error("Organization ID is required");
    }

    const response = await get<any>(`${basePath}/`, {
      params: {
        org_id: organizationId,
      },
    });

    // Handle different response structures
    if (Array.isArray(response)) {
      return response;
    }

    if (response?.results && Array.isArray(response.results)) {
      return response.results;
    }

    if (response?.data && Array.isArray(response.data)) {
      return response.data;
    }

    return [];
  };

  /**
   * Get SOP counts by organization ID
   */
  getSOPCounts = async (
    organizationId: string
  ): Promise<{
    departments: Array<{
      department_id: string | null;
      department_name: string;
      sop_count: number;
    }>;
    document_types: Array<{
      document_type: string;
      count: number;
    }>;
  }> => {
    if (!organizationId) {
      throw new Error("Organization ID is required");
    }

    const response = await get<any>(`${basePath}/sop-counts/`, {
      params: {
        org_id: organizationId,
      },
    });

    // Handle nested response structure: response.data
    if (response?.data) {
      return response.data;
    }

    return response;
  };
}

const instance = new SOPService();
export default instance;
